import {DormerRootState} from "../DormerRootState";
import {Notification} from "@hec/models";

export const getNotificationsSelector = (state: DormerRootState): Notification[] => {
  return state.notifications.notifications
}
